import actionTypes from './actionTypes';

export const batchSalesOrders = (values) => ({
  type: actionTypes.BATCH_SALES_ORDERS,
  payload: {
    values,
  },
});

export const batchedSalesOrders = (data) => ({
  type: actionTypes.BATCHED_SALES_ORDERS,
  payload: {
    data,
  },
});

export const batchedSuccessfully = () => ({
  type: actionTypes.BATCHED_SUCCESSFULLY,
  payload: {},
});
